// What the practice says to a patient whose appointment has been cancelled.
//
// Deliberately not apologetic. The office cancels for many reasons — including
// at the patient's own request — so a blanket "sorry" is wrong about as often
// as it is right, and it reads as boilerplate either way. It states what has
// happened and offers a way back.

type Notice = {
  patientName: string;
  /** Already formatted for a person: "Wednesday 2 September at 2:30 PM". */
  when: string;
  /** A single-use booking link, when the practice has self-booking on. */
  bookingUrl?: string;
};

const firstName = (full: string): string =>
  String(full || '').trim().split(/\s+/)[0] || 'there';

export function cancellationNotice({ patientName, when, bookingUrl }: Notice): string {
  const opening = when
    ? `your appointment on ${when} has been cancelled.`
    : `your appointment has been cancelled.`;

  // A link when there is one, an invitation to reply when there is not. Never
  // "click here to rebook" with nothing behind it.
  const wayBack = bookingUrl
    ? `You can pick a new time here: ${bookingUrl}`
    : `Reply to this message and we'll find you another time.`;

  return `Hi ${firstName(patientName)} — ${opening} ${wayBack}`;
}
